export default __webpack_public_path__ + "static/media/mechanismInfo.844405a3.svg";